import ApiService from '@/api';
import {
  SettingsBreadcrumbsModel,
  NamespaceModel,
  ResponseModel,
  UpdateQueueNameModel,
  GroupUpdateNameEventResponseModel,
} from '../models';
import { mapGetBreadcrumbsRequest, mapGetBreadcrumbsResponse } from './AdapterServiceMappers';
import { UpdateNamespaceInfo } from '../types';
import { Events } from 'tir-pm-toolkit';

export class MenuBreadcrumbsAdapterService {
  private readonly api = new ApiService();
  /**Событие обновления неймспейса */
  UpdateNamespaceEvent = new Events<UpdateNamespaceInfo>();
  /**Событие обновления очереди */
  UpdateQueueEvent = new Events<UpdateQueueNameModel>();
  /**Событие обновления названия папки */
  OnUpdateNameGroupEvent = new Events<GroupUpdateNameEventResponseModel>();

  constructor() {
    this.api.Main.ProjectNamespaceService.OnUpdateNamespaceEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.UpdateNamespaceEvent.trigger({
          Id: resp.Value.Id,
          Name: resp.Value.Name,
          IconId: resp.Value.IconId,
          IconUrl: resp.Value.IconUrl,
          ColorId: resp.Value.ColorId,
          Color: resp.Value.Color,
        });
      }
    });

    this.api.Main.ProjectQueueTaskService.OnUpdateNameQueueTaskEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.UpdateQueueEvent.trigger({
          QueueId: resp.Value.Id,
          Name: resp.Value.Name,
        });
      }
    });
    this.api.Main.ProjectGroupService.OnUpdateNameGroupEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.OnUpdateNameGroupEvent.trigger(resp.Value);
      }
    });
  }

  /**
   * * Получить хлебные крошки
   * @param request
   * @returns
   */
  getBreadcrumbs(request: SettingsBreadcrumbsModel) {
    return new Promise<ResponseModel<NamespaceModel>>(async (resolve) => {
      const result = new ResponseModel<NamespaceModel>();

      await this.api.Main.ProjectNamespaceService.getParentPathAsync(
        mapGetBreadcrumbsRequest(request),
      )
        .then((resp) => {
          result.Value = mapGetBreadcrumbsResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getBreadcrumbs', e);
          return resolve(result);
        });
    });
  }
}
